export default __webpack_public_path__ + "static/media/coora.7339bcb8.jpg";